import Flux from '../flux';
var WorkflowErrandActions = Flux.createActions({
	updateCKE: function(ctx){
		return ctx;
	}
});
export default WorkflowErrandActions;